import { useState } from "react";
import { BG, CARD, CARD2, CARD3, BD, TX, TX2, BL, GR, RD } from "./utils/constants";
import axios, { TOKEN_KEY } from "./utils/api";

export default function ResetPassword({ token, onDone }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  const submit = async () => {
    if (!password || password.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (password !== confirm) { setError("Passwords don't match."); return; }
    setLoading(true); setError("");
    try {
      const res = await axios.post("/api/auth/reset-password", { token, password });
      localStorage.setItem(TOKEN_KEY, res.data.token);
      onDone(res.data.user);
    } catch (e) {
      setError(e?.response?.data?.error || "Could not reset password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ts-scan-shell" style={{ minHeight: "100vh", background: BG, color: TX, fontFamily: "'IBM Plex Mono',monospace", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=Space+Grotesk:wght@800&display=swap');`}</style>
      <div className="ts-panel" style={{ background: CARD, border: `1px solid ${BD}`, borderRadius: 14, padding: 28, maxWidth: 420, width: "100%", boxShadow: "0 28px 80px rgba(0,0,0,0.45)" }}>
        <div className="ts-gradient-text" style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 900, fontSize: 22, marginBottom: 8 }}>
          Choose a new password
        </div>
        <div style={{ color: TX2, fontSize: 11, lineHeight: 1.8, marginBottom: 20 }}>
          Enter a new password for your account.
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: "block", fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 5 }}>NEW PASSWORD</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            onKeyDown={(e) => e.key === "Enter" && submit()}
            style={{ width: "100%", background: CARD3, border: `1px solid ${BD}`, borderRadius: 8, padding: "10px 14px", color: TX, fontSize: 11, boxSizing: "border-box", fontFamily: "'IBM Plex Mono', monospace", outline: "none" }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={{ display: "block", fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 5 }}>CONFIRM PASSWORD</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            placeholder="••••••••"
            onKeyDown={(e) => e.key === "Enter" && submit()}
            style={{ width: "100%", background: CARD3, border: `1px solid ${BD}`, borderRadius: 8, padding: "10px 14px", color: TX, fontSize: 11, boxSizing: "border-box", fontFamily: "'IBM Plex Mono', monospace", outline: "none" }}
          />
        </div>

        {error && (
          <div style={{ background: `${RD}12`, border: `1px solid ${RD}40`, borderRadius: 8, padding: "9px 13px", fontSize: 10, color: RD, marginBottom: 16, lineHeight: 1.5 }}>
            {error}
          </div>
        )}

        <button
          onClick={submit}
          disabled={loading}
          style={{ width: "100%", background: loading ? CARD2 : `linear-gradient(135deg,${GR},${BL})`, border: "none", borderRadius: 10, padding: "13px 0", color: loading ? TX2 : "#000", fontSize: 11, fontWeight: 800, cursor: loading ? "not-allowed" : "pointer", letterSpacing: 2 }}
        >
          {loading ? "SAVING..." : "RESET PASSWORD →"}
        </button>
      </div>
    </div>
  );
}
